import React from 'react';
import './App.css';
import HomeScreen from "./HomeScreen"
import Header from "./Header"
import TrumpPlan from "./TrumpPlan"
import Footer from "./Footer"
import YourView from "./YourView"


function App() {
  return (
      <div>
        <Header/>
        <HomeScreen/>
        <TrumpPlan/>
        <YourView/>
        <Footer/>
      </div>
    )
  }


export default App;
